import { CartListTraining } from '../components/Checkout/Checkout.interface';
import { array } from 'yup';

export enum TrainingOrderType {
  NORMAL = 'normal',
  CONTACT = 'contact',
  PREREGISTER = 'preregister',
}

export interface Examentraining {
  beschikbare_capaciteit: string;
  datum_eind: string;
  datum_start: string;
  general_end_time: string;
  general_start_time: string;
  id_product: string;
  id_subtype: string;
  id_training: string;
  label_naam: string;
  last_updated: string;
  loc_email: string;
  loc_lat: string;
  loc_long: string;
  loc_naam: string;
  loc_nr: string;
  loc_postcode: string;
  loc_routelink: string;
  loc_stad: string;
  loc_straat: string;
  loc_telefoon: string;
  loc_type: string;
  loc_vestiging_foto_url: string;
  opmerking_extern: string;
  order_type: TrainingOrderType;
  prijs: string;
  product_naam: string;
  product_subtype: string;
  product_type: string;
  training_dates: string;
  training_opmerking_extern: string;
  vak_naam: string;
  vak_niveau: string;
  zichtbaar: 'yes'|'no';
  fomo_1;
}

/**
 * The search results as returned by the search page.
 */
export interface TrainingSearchResult extends Examentraining {
  distance: number;
  dateGroup: 'Deze week'|'Volgende week'|'Later'; // TODO enum
}

export const EXAMENTRAINING_MOCK: Examentraining = {
  beschikbare_capaciteit: '20',
  datum_eind: '2019-02-19',
  datum_start: '2019-02-18',
  general_end_time: '18:00:00',
  general_start_time: '09:00:00',
  id_product: '56',
  id_subtype: '22',
  id_training: '86237',
  label_naam: 'Lyceo',
  last_updated: '2019-02-02',
  loc_email: 'info@lyceo.nl',
  loc_lat: '53.21989059448',
  loc_long: '6.57309389114',
  loc_naam: 'Lyceo Amsterdam Van Baerlestraat',
  loc_nr: '11',
  loc_postcode: '9711VG',
  loc_routelink: '',
  loc_stad: 'Groningen',
  loc_straat: 'Nieuwe Sint Jansstraat',
  loc_telefoon: '071 - 79 000 40',
  loc_type: '1',
  loc_vestiging_foto_url: 'https://i.ytimg.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
  opmerking_extern: 'De Examentraining opmerking',
  order_type: TrainingOrderType.NORMAL,
  prijs: '278.00',
  product_naam: 'Examentraining Voorjaarsvakantie',
  product_subtype: 'Lyceo ET',
  product_type: 'Examentraining',
  training_dates: '2019-02-18,2019-02-19',
  training_opmerking_extern: '2-daagse',
  vak_naam: 'Engels',
  vak_niveau: 'HAVO',
  zichtbaar: 'yes',
  fomo_1: [],
};

const monthLabelShort = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];

/**
 * Create the label for the provided training.
 *
 * @example
 * HAVO, 1 t/m 3 jan, 09:00 - 17:00
 * HAVO, 1 en 2 jan, 09:00 - 17:00
 * HAVO, 28 jan t/m 2 feb, 09:00 - 17:00
 */
export function getExamentrainingDatesLabel(training: Examentraining|CartListTraining): string {
  // count date from UTC time in case people visit the lyceo website from other parts of the world
  let timezone: string = 'T00:00:00Z';
  let startDate: Date = new Date(training.datum_start + timezone);
  let endDate: Date = new Date(training.datum_eind + timezone);
  const days: number = training.training_dates.split(',').length;

  // set date labels (21 - 23 jan) or (31 jan - 2 feb)
  const beginMaand: string = monthLabelShort[startDate.getUTCMonth()];
  const eindMaand: string = monthLabelShort[endDate.getUTCMonth()];
  const begin: string = startDate.getUTCDate() + (beginMaand !== eindMaand ? ` ${beginMaand}` : '');
  const eind: string = `${endDate.getUTCDate()} ${eindMaand}`;

  const startTime: string = training.general_start_time.slice(0, 5);
  const endTime: string = training.general_end_time.slice(0, 5);

  return `${begin} ${days === 2 ? 'en' : 't/m'} ${eind}, ${startTime} - ${endTime}`;
}
